import { Component, OnInit } from '@angular/core';
import { AuthAccessProvider } from '../core/core.auth';
import { MessageProvider } from '../service/message.service'
import { UserService} from '../service/user.service';
import { Router } from '@angular/router';
import { UserContext, BaseComponent, UserInfo } from '../core/core.component';

@Component({
  selector: 'app-gestione-commesse',
  templateUrl: './gestione-commesse.component.html',
  styleUrls: ['./gestione-commesse.component.css']
})
export class CommesseComponent  extends BaseComponent implements OnInit 
{
    userContext: UserContext;
    userInfo: UserInfo;
    displayClients: string = "";
    displayOffers: string = "active";
    displayScadenzeFatturazione: string = "";
    displayStime :string= "";
    displayStatistiche : string="";
    displayTicketDaFatturare: string = "";
    displayAnalisiTicket: string = "";
    clientsInitialized: boolean = false;
    offersInitialized: boolean = true;
    scadenzeFatturazioneInitialized: boolean = false;
    stimeInitialized: boolean = false;
    statisticheInitialized: boolean = false;
    ticketDaFatturareInitialized: boolean = false;
    analisiTicketInitialized: boolean = false;
  
    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider,
            private userService: UserService)
    { 
        super(authAccess, router, messageProvider);
        this.messageProvider.clearAll();
    }

    ngOnInit() 
    {
        this.userContext = this.authAccess.getUserContext();
        if(this.userContext == null) {    
            this.authAccess.invalidate();
        } else {
            this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
                result => {
                    this.userInfo = result;
                },
                error => {
                    this.handleError(error);
                }
            );
        }
    }
  
    backToHome() {
        this.router.navigate(["/"]);
    }
    
   display(section: string) 
   {
      this.displayClients = "";
      this.displayOffers = "";
      this.displayScadenzeFatturazione = "";
      this.displayStime = "";
      this.displayStatistiche="";
      this.displayTicketDaFatturare = "";
      this.displayAnalisiTicket = "";
      if(section == "clients") {
          this.displayClients = "active";
          this.clientsInitialized = true;
      }if(section == "offers") {
          this.displayOffers = "active";
          this.offersInitialized = true;
      }
      if(section == "scadenzeFatturazione") {
        this.displayScadenzeFatturazione = "active";
        this.scadenzeFatturazioneInitialized = true;
    }
    if(section == "stime"){
        this.displayStime="active";
        this.stimeInitialized = true;
    }
     if(section == "statistiche"){
        this.displayStatistiche="active";
        this.statisticheInitialized = true;
    }
     if(section == "ticketDaFatturare"){
        this.displayTicketDaFatturare="active";
        this.ticketDaFatturareInitialized = true;
    }
     if(section == "analisiTicket"){
        this.displayAnalisiTicket="active";
        this.analisiTicketInitialized = true;
    }
   }
  
}



// WEBPACK FOOTER //
// ./src/app/gestione-commesse/gestione-commesse.component.ts